<div fxFlex fxLayout="column" class="">
  <h3 class="page-title">{{ title }}</h3>
  <div
    fxFlex
    fxLayout
    class="core-list page_heading list-grid-options"
    [ngClass]="{ headerSmallSize: headerSmallSize }"
    id="tableOptions"
  >
    <app-list-grid-options
      fxFlex
      [listOptions]="listOptions"
      [showTitle]="showTitle"
      [service]="service"
      (openForm)="openForm({ open: true })"
    ></app-list-grid-options>
  </div>
  <div fxFlex fxLayout="row" fxLayoutAlign="space-between center" class="filter-section">
    <div class="actions">
      <button mat-stroked-button class="primary-border" (click)="exportMultiple()">
        <!--      <mat-icon class="icon-lg ml10 v-a-m main-color">import_export</mat-icon>-->
        <mat-icon class="icon-lg ml10 mtn10 mtn5 main-color" svgIcon="export-flat"></mat-icon>
        {{ 'common.export' | translate }}
      </button>
    </div>

    <div fxFlex fxLayout="row" fxLayoutAlign="end center">
      <button mat-button [matMenuTriggerFor]="menu">
        <mat-icon
          _ngcontent-c1=""
          class="mat-icon mat-default material-icons"
          role="img"
          aria-hidden="true"
          ng-reflect-color="default"
          >filter_list</mat-icon
        >
        {{ 'common.filter' | translate }}
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="filterPeriod('yesterday')">{{ 'dashboard.yesterday' | translate }}</button>
        <button mat-menu-item (click)="filterPeriod('lastWeek')">{{ 'dashboard.lastWeek' | translate }}</button>
        <button mat-menu-item (click)="filterPeriod('lastMonth')">{{ 'dashboard.lastMonth' | translate }}</button>
      </mat-menu>
    </div>
  </div>
  <div class="table-container table-shadow table-overflow">
    <app-table
      [data]="tableData"
      [columns]="columns"
      [options]="{
        details: false
      }"
    >
    </app-table>
  </div>
</div>
